import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts.css'; // 导入自定义字体
import App from './App';
import reportWebVitals from './reportWebVitals';

// 忽略 ResizeObserver 无害警告（批量操作时浏览器来不及处理所有通知）
const resizeObserverLoopErrRe = /^ResizeObserver loop/;
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.toString?.().match(resizeObserverLoopErrRe)) {
    return; // 静默此错误
  }
  originalError(...args);
};

// 🛡️ 必须用 捕获阶段(true) 才能抢在 CRA error overlay 之前拦截
window.addEventListener('error', (e) => {
  if (resizeObserverLoopErrRe.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

// 注册字体缓存 Service Worker（使字体永久驻留本地，不再受 HTTP 缓存清理影响）
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-fonts.js').catch(() => {});
  });
}

// 🗄️ 申请「持久化存储」：防止浏览器在磁盘紧张时清空 IndexedDB 图片缓存。
//   iOS Safari 尤其关键——未申请持久化的站点 7 天不访问即被清空所有存储，
//   导致每次打开老项目都要从 OSS 重新下载全部图片。申请后缓存长期驻留。
//   桌面 Chrome 同理（磁盘压力下会被 evict）。静默失败不影响正常流程。
if (navigator.storage && typeof navigator.storage.persist === 'function') {
  navigator.storage.persisted?.().then((already) => {
    if (!already) navigator.storage.persist().catch(() => {});
  }).catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
